"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const shared_1 = require("../shared");
const Card_1 = __importDefault(require("@mui/material/Card"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const Stack_1 = __importDefault(require("@mui/material/Stack"));
const styles_1 = require("@mui/material/styles");
const Button_1 = __importDefault(require("@mui/material/Button"));
const shared_2 = require("../shared");
const react_router_dom_1 = require("react-router-dom");
const react_cookie_1 = require("react-cookie");
const react_router_dom_2 = require("react-router-dom");
require("react-responsive-carousel/lib/styles/carousel.min.css");
const react_responsive_carousel_1 = require("react-responsive-carousel");
const Checkbox_1 = __importDefault(require("@mui/material/Checkbox"));
const settings = {
    showArrows: true,
    infiniteLoop: true,
    showIndicators: false,
    swipeable: true,
    useKeyboardArrows: true,
    showThumbs: false,
    showStatus: true,
};
const Subscriptions = () => {
    const { userId } = (0, react_router_dom_2.useParams)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [subscriptionList, setSubscriptionList] = react_1.default.useState([]);
    const [termsCheck, setTermsCheck] = react_1.default.useState({});
    const [termsUrl, setTermsurl] = react_1.default.useState('');
    const md = require('markdown-it')({
        html: true,
        linkify: true,
        typographer: true,
    });
    (0, react_1.useEffect)(() => {
        initData();
        populateSession();
    }, []);
    const initData = async () => {
        const subData = await (0, shared_2.getDesmosSubscribed)(userId);
        let redirect_url = await (0, shared_2.getMainUrl)();
        setTermsurl(redirect_url + '/terms-and-conditions');
        if (subData === null || subData === void 0 ? void 0 : subData.isSubscribed) {
            navigate(`/desmos-main/${userId}`);
        }
    };
    const populateSession = async (onLoad) => {
        try {
            const data = await (0, shared_1.getStrapiData)(`subscriptions?&sort=displayOrder:asc`);
            if (data.length > 0) {
                const subList = [];
                const chunkSize = 4;
                for (let i = 0; i < data.length; i += chunkSize) {
                    subList.push(data.slice(i, i + chunkSize));
                }
                setSubscriptionList(subList || []);
            }
        }
        catch (error) { }
    };
    const handleNotification = (index) => (event) => {
        const checked = event.target.checked;
        setTermsCheck(Object.assign(Object.assign({}, termsCheck), { [index]: checked }));
    };
    const handleSubscribe = (planId) => async (event) => {
        const regData = await (0, shared_1.getUserData)();
        const user = await (0, shared_1.getCurrentUser)();
        const cookies = new react_cookie_1.Cookies();
        const domain = (0, shared_2.getDomain)();
        let redirect_url = await (0, shared_2.getMainUrl)();
        let redirect_url_payment = redirect_url + `/makePayment`;
        let redirect_url_register = redirect_url + `/registration`;
        let redirect_url_confirm = redirect_url + `/confirm`;
        cookies.remove('desmos_subscription_id', domain);
        cookies.remove('payment_source_from', domain);
        cookies.set('desmos_subscription_id', planId, domain);
        cookies.set('payment_source_from', 'desmos_subscription', domain);
        if (user === null) {
            window.location.replace(redirect_url_confirm);
        }
        else if (regData === null) {
            window.location.replace(redirect_url_register);
        }
        else {
            window.location.replace(redirect_url_payment);
        }
    };
    const SubButton = (0, styles_1.styled)(Button_1.default)(({ theme }) => ({
        color: '#FFFF',
        background: 'blue',
        textTransform: 'none',
        fontFamily: 'Poppins',
        fontSize: '1.25vmax',
        justifyContent: 'center',
        fontWeight: 'bold',
        alignContent: 'center',
        width: '25vh',
        borderRadius: '12px',
        '&:hover': {
            background: 'linear-gradient(180deg, #0146C7 0%, #053898 100%)',
        },
        '&.Mui-disabled': {
            color: '#F2F2F2',
            background: 'grey',
        },
    }));
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'home-page-root' }, { children: [(0, jsx_runtime_1.jsx)("img", { src: '/assets/background_5.png', alt: 'home-screen', className: 'bg_1_image', loading: 'lazy' }), (0, jsx_runtime_1.jsxs)(Stack_1.default, Object.assign({ direction: 'column', spacing: 4, sx: { width: '100%', zIndex: 1 } }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ className: 'college_link_header' }, { children: "SUBSCRIPTION PLANs" })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'sub-par-div-style' }, { children: (subscriptionList === null || subscriptionList === void 0 ? void 0 : subscriptionList.length) > 0 ? ((0, jsx_runtime_1.jsx)(react_responsive_carousel_1.Carousel, Object.assign({ showArrows: settings.showArrows, infiniteLoop: settings.infiniteLoop, showIndicators: settings.showIndicators, swipeable: settings.swipeable, useKeyboardArrows: settings.useKeyboardArrows, showThumbs: settings.showThumbs, showStatus: settings.showStatus }, { children: (subscriptionList || []).map((item, i) => ((0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ container: true, spacing: 2, style: { justifyContent: 'center' } }, { children: (item || []).map((c, index) => {
                                    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                                    return ((0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ display: 'flex', flexDirection: 'row', container: true, padding: 2, width: '48vh' }, { children: [((_a = c === null || c === void 0 ? void 0 : c.attributes) === null || _a === void 0 ? void 0 : _a.MostPopular) && (0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'sub-most-pop-style' }, { children: "Most Popular!" })), ((_b = c === null || c === void 0 ? void 0 : c.attributes) === null || _b === void 0 ? void 0 : _b.MostPopular) != true && (0, jsx_runtime_1.jsx)("div", { className: 'sub-non-pop-style' }), (0, jsx_runtime_1.jsx)(Card_1.default, Object.assign({ className: ((_c = c === null || c === void 0 ? void 0 : c.attributes) === null || _c === void 0 ? void 0 : _c.MostPopular) ? 'sub-card-style' : 'sub-card-rad-style', sx: { boxShadow: 20, ':hover': { backgroundColor: 'blue' } } }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: ((_d = c === null || c === void 0 ? void 0 : c.attributes) === null || _d === void 0 ? void 0 : _d.MostPopular) ? 'sub-main-div-style' : 'sub-main-div-rad-style' }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'sub-period-style' }, { children: (_e = c === null || c === void 0 ? void 0 : c.attributes) === null || _e === void 0 ? void 0 : _e.Period })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'sub-monthly-style' }, { children: ["$", ((_f = c === null || c === void 0 ? void 0 : c.attributes) === null || _f === void 0 ? void 0 : _f.IsAutoRenewal) ? ((_g = c === null || c === void 0 ? void 0 : c.attributes) === null || _g === void 0 ? void 0 : _g.Amount) + '/Month' : (_h = c === null || c === void 0 ? void 0 : c.attributes) === null || _h === void 0 ? void 0 : _h.Amount] })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'sub-desc-style' }, { children: (0, jsx_runtime_1.jsx)("span", { dangerouslySetInnerHTML: { __html: md.render((_j = c === null || c === void 0 ? void 0 : c.attributes) === null || _j === void 0 ? void 0 : _j.Description) } }) })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ style: { display: 'inline-flex', alignItems: 'center' } }, { children: [(0, jsx_runtime_1.jsx)(Checkbox_1.default, { color: 'primary', checked: termsCheck === null || termsCheck === void 0 ? void 0 : termsCheck[index], onChange: handleNotification(index) }, index), (0, jsx_runtime_1.jsxs)("span", Object.assign({ style: { fontSize: '1.6vh', alignItems: 'center' } }, { children: ["I agree to the\u00A0", (0, jsx_runtime_1.jsx)("a", Object.assign({ target: '_blank', href: termsUrl, className: 'make_payment_cancel' }, { children: "Terms and Conditions" }))] }))] })), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(SubButton, Object.assign({ color: 'primary', disabled: !(termsCheck === null || termsCheck === void 0 ? void 0 : termsCheck[index]), onClick: handleSubscribe(c.id) }, { children: "Subscribe" })) })] })) }))] }), index));
                                }) }), i))) }))) : ((0, jsx_runtime_1.jsx)("div", { style: { height: '50vh' } })) })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'sub-div-footer-style' }, { children: [(0, jsx_runtime_1.jsx)("b", { children: "Questions?" }), (0, jsx_runtime_1.jsxs)("div", { children: ["Contact us at\u00A0", (0, jsx_runtime_1.jsx)("a", Object.assign({ href: 'mailto:info@alphaprep.com' }, { children: "info@alphaprep.com" })), "\u00A0or ", (0, jsx_runtime_1.jsx)("a", Object.assign({ href: '' }, { children: "+18888425742" }))] })] }))] }))] })));
};
exports.default = Subscriptions;
